import { useParams } from 'react-router-dom';
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ViewTable from 'app/shared/view-table/view-table';
import ViewTableHeaderColumn from 'app/shared/view-table/view-table-header-column';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Button } from 'edozvola-frontend-lib/dist/ui/components';
import { deleteAddedPersonQuery, fetchAddedPeopleQuery } from 'app/edozvola/cases/added-person/service/added-person.queries';
import { AddedPersonView } from 'app/edozvola/cases/added-person/model/added-person.model';
import { TABLE_QUERY_KEYS } from 'app/config/constants';
import { getInvalidRowsForTable } from 'app/shared/util/validation-errors.util';
import { getCaseContext } from 'app/shared/util/context-util';
import { TooltipWrapper } from 'edozvola-frontend-lib/dist/ui/components/tooltipwrapper';

const AddedPersonTable = ({ setAddedPerson, setReadOnly }) => {
  const { id } = useParams<{ id: string }>();
  const [idAddedPersonToDelete, setIdAddedPersonToDelete] = useState();
  const [deleteModalShown, setDeleteModalShown] = useState(false);
  const { sidebarItemPair } = getCaseContext();

  const invalidRowIds = getInvalidRowsForTable(TABLE_QUERY_KEYS.ADDED_PEOPLE_TABLE);

  const { mutate: deleteAddedPersonMutation, isPending: addedPersonDeletionPending } = deleteAddedPersonQuery();

  const openDeleteDialog = idToDelete => {
    setIdAddedPersonToDelete(idToDelete);
    setDeleteModalShown(true);
  };

  const removeAddedPerson = () => {
    setDeleteModalShown(false);
    deleteAddedPersonMutation(idAddedPersonToDelete);
  };

  const openAddedPersonForm = (idAddedPerson: number, readOnly: boolean) => {
    setAddedPerson(idAddedPerson);
    setReadOnly(readOnly);
  };

  const renderTableRow = (value: AddedPersonView, partyIndex: number, totalItems: number) => {
    return (
      <tr key={partyIndex} className={invalidRowIds.includes(value.idAddedPerson) ? 'invalid-table-row' : ''}>
        <td>{value.name}</td>
        <td>{value.oibMb}</td>
        <td>{value.address}</td>
        <td>{value.email}</td>
        <td>
          <div className={'actions-container'}>
            {sidebarItemPair?.canView && (
              <TooltipWrapper message={'Pregledaj'}>
                <FontAwesomeIcon icon={'eye'} className={'icon-table'} onClick={() => openAddedPersonForm(value.idAddedPerson, true)} />
              </TooltipWrapper>
            )}
            {sidebarItemPair?.canEdit && (
              <TooltipWrapper message={'Uredi'}>
                <FontAwesomeIcon
                  icon={'pen-to-square'}
                  className={'icon-table'}
                  onClick={() => openAddedPersonForm(value.idAddedPerson, false)}
                />
              </TooltipWrapper>
            )}
            {sidebarItemPair?.canDelete && (
              <TooltipWrapper message={'Obriši'}>
                <FontAwesomeIcon icon={'trash-alt'} className={'icon-table'} onClick={() => openDeleteDialog(value.idAddedPerson)} />
              </TooltipWrapper>
            )}
          </div>
        </td>
      </tr>
    );
  };

  return (
    <>
      <ViewTable
        renderTableRow={renderTableRow}
        noDataMessage={'Nema dodanih osoba'}
        initialPaginationColumn={'idAddedPerson'}
        fetchDataQuery={fetchAddedPeopleQuery}
        fetchDataProps={[id]}
      >
        <ViewTableHeaderColumn renderSort sortKey={'name'} columnLabels={['Ime i prezime/Naziv']} width={'15%'} />
        <ViewTableHeaderColumn renderSort sortKey={'oibMb'} columnLabels={['OIB/MB']} width={'5%'} />
        <ViewTableHeaderColumn renderSort sortKey={'address'} columnLabels={['Adresa']} width={'15%'} />
        <ViewTableHeaderColumn renderSort sortKey={'email'} columnLabels={['Email']} width={'10%'} />
        <ViewTableHeaderColumn renderSort={false} columnLabels={['Akcije']} width={'3%'} />
      </ViewTable>
      <Modal scrollable isOpen={deleteModalShown} size={'lg'} toggle={() => setDeleteModalShown(false)} centered>
        <ModalHeader>
          <span>Brisanje dodane osobe</span>
        </ModalHeader>
        <ModalBody>
          <div>Jeste li sigurni da želite obrisati podatke?</div>
        </ModalBody>
        <ModalFooter>
          <Button size={'lg'} label="Odustani" outline onClick={() => setDeleteModalShown(false)} />
          <Button size={'lg'} label="Obriši" color={'danger'} onClick={removeAddedPerson} />
        </ModalFooter>
      </Modal>
    </>
  );
};

export default AddedPersonTable;
